import { useMemo } from 'react';
import { getStepStatus } from '../utils/stepsHelpers';

export const useSteps = ({ current = 0, items = [] }) => {
  const processedItems = useMemo(() => {
    return items.map((item, index) => {
      const status = getStepStatus(index, current);
      const isCompleted = status === 'completed';
      const isActive = status === 'active';
      return {
        ...item,
        index,
        status,
        isCompleted,
        isActive,
      };
    });
  }, [current, items]);

  return {
    processedItems,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Steps/hooks/useSteps.js